import { API_PATHS } from "../constants/api-paths";
import { CS_REQUEST_ID, FPR_DATA_STORAGE_KEY, FPR_STAGES } from "../constants/fpr";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { logCustomAttributeToNewRelic } from "../utils/logging";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { getCustomerDemogFromApp, setCookie } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../core/api.client";
import { ICustomerDetails } from "./autofetchDetails.service";

export interface ISubscriptionDetailsResponse {
  paymentGatewayURL: string;
  paymentGatewayParameters: string;
  currentLimit: number;
  newLimit: number;
  feeAmount: number;
  landingPage: string;
  cardType: string;
  aaUrl: string;
  cardNumber: string;
  status: string;
  message: string;
  requestDatetime: string;
  responseDatetime: string;
  podRequestId: number;
  csRequestId: number;
  channelId: string;
  currentStage: string;
  nextStage: typeof FPR_STAGES;
  customerId: string;
  customerFullName: string;
  customerType: string;
  redirectionUrl: string;
  fprReportDate: string;
  isExpired: boolean;
  daysAfterExpiry: number;
  paymentTxnReferenceNumber: string;
  paymentSdkSaltKey: string;
  paymentSdkSubChannel: string;
  customerDetails: ICustomerDetails;
  pdpBypass: boolean;
}

export interface ISubscriptionDetailsRequest {
  mobileNo: string;
}

const getSubscriptionDetails = async (): Promise<
  IResponse<ISubscriptionDetailsResponse> | undefined
> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const encryptedReq = {
      mobileNo: mobileNo || getCustomerDemogFromApp().mobileNo,
    };
    const response = await encryptedRequest<
      ISubscriptionDetailsResponse,
      ISubscriptionDetailsRequest
    >({
      method: "POST",
      url: API_PATHS.subscriptionDetails,
      data: encryptedReq,
      storeResponseInLocal: true,
      storageKey: FPR_DATA_STORAGE_KEY,
    });
    if (response.statusCode !== 90) {
      throw new Error(response.message);
    }
    setCookie(CS_REQUEST_ID, 0, `${response.data.csRequestId}`);
    return response;
  } catch (err) {
    logCustomAttributeToNewRelic(
      "FPR_SUBSCRIPTION_DETAILS_API_ERROR_COOKIES",
      JSON.stringify({
        cookies: document.cookie,
      })
    );
    logCustomAttributeToNewRelic(
      "FPR_SUBSCRIPTION_DETAILS_API_ERROR_DETAILS",
      JSON.stringify({
        status: "FETCH_ERROR",
        app_ver:
          globalThis.window.location.href.includes("/app-v1") &&
          globalThis.window.prompt("getAppVersion://"),
        URL: globalThis.window.location.href,
        mobileNo: btoa(mobileNo),
        errorDetails: JSON.stringify(err),
        tokenFromPrompt:
          (globalThis.window.location.href.includes("/app-v1") &&
            globalThis.window.prompt("refreshToken")) ||
          "No Token",
        userDataFromPrompt:
          (globalThis.window.location.href.includes("/app-v1") &&
            globalThis.window.prompt("customerdemoapidata")) ||
          "No Data",
      })
    );
  }
};

export default getSubscriptionDetails;
